"use client";

import { useEffect } from "react";
import { CACHE_BUST_PARAM, RECOVERY_KEY } from "@/app/hooks/useErrorAutoReload";

const HEALTHY_AFTER_MS = 10_000;

const RecoveryReset = () => {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      try {
        window.sessionStorage.removeItem(RECOVERY_KEY);
      } catch {
        // Storage-disabled browsers safely skip automatic recovery.
      }
    }, HEALTHY_AFTER_MS);

    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has(CACHE_BUST_PARAM)) {
        url.searchParams.delete(CACHE_BUST_PARAM);
        window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
      }
    } catch {
      // URL cleanup must never affect rendering.
    }

    return () => window.clearTimeout(timer);
  }, []);

  return null;
};

export default RecoveryReset;